import React, { useState } from "react";
import ContentPageEditor from "./ContentPageEditor";

const TABS = [
  { slug: "privacy-policy", label: "Privacy Policy" },
  { slug: "terms-of-service", label: "Terms of Service" },
  { slug: "cookie-policy", label: "Cookie Policy" },
];

const ContentPagesManager = () => {
  const [activeSlug, setActiveSlug] = useState(TABS[0].slug);

  return (
    <div className="space-y-6">
      {/* Tab switcher */}
      <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-1.5 flex gap-1">
        {TABS.map((tab) => (
          <button
            key={tab.slug}
            onClick={() => setActiveSlug(tab.slug)}
            className={`flex-1 py-2.5 px-4 rounded-xl text-sm font-semibold transition-all duration-150 ${
              activeSlug === tab.slug
                ? "bg-slate-900 text-white shadow"
                : "text-slate-500 hover:text-slate-800 hover:bg-slate-50"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Active editor */}
      {TABS.map((tab) =>
        tab.slug === activeSlug ? (
          <ContentPageEditor
            key={tab.slug}
            slug={tab.slug}
            pageLabel={tab.label}
          />
        ) : null,
      )}
    </div>
  );
};

export default ContentPagesManager;
